'use strict'

export const CONFIG = {
  firebase: {
    apiKey: 'AIzaSyBpOhk18REgOCKaPn7f-IDV4kgHYoGTFPE',
    authDomain: 'rosmar-web.firebaseapp.com',
    databaseURL: 'https://rosmar-web.firebaseio.com',
    projectId: 'rosmar-web',
    storageBucket: 'rosmar-web.appspot.com',
    messagingSenderId: '801945243124',
    appId: '1:801945243124:web:116079c3a6d5ff1988bda1',
    measurementId: 'G-MCBC9EQ72Z',
  },
  reCaptcha: {
    sitekey: '6LctnMQZAAAAAHETS2MnDouCwpHFrwJrqiFJLR4Z',
  },
}
